import Header from "../Header";
import MenuBar from "../Public/Footer/MenuBar";
import PointChargePage from "./PointChargePage";

const PointPageMain = () => {
  return (
    <div>
      <Header></Header>
      <PointChargePage></PointChargePage>
      <MenuBar></MenuBar>
    </div>
  );
};

export default PointPageMain;
